<nav class="text-base flex flex-row justify-between border-b border-grayLight bg-white" style="z-index: 51">
  <div class="shrink-0" [style.background]="NavbarColor">
    <a [routerLink]="'/admin/dashboard'" i18n-title title="Domov" class="h-full flex items-center">
      <!-- Full logo -->
      <div class="hidden md:flex items-center px-4 md:pl-8 md:pr-10 w-sidebar">
        <img
            [src]="brandService.config.logoSrcLight"
            [alt]="brandService.config.appName"
            class="w-full h-auto"
        />
      </div>

      <!-- Just emblem -->
      <div class="block md:hidden py-4 px-4 md:pl-8 md:pr-10">
        <svg class="block md:hidden" width="23" height="23" viewBox="0 0 152 152" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
                  d="M34.2799 84.72C52.8399 84.72 67.8799 99.76 67.8799 118.32V151.92H34.2799H0.679932V118.32C0.679932 99.76 15.7199 84.72 34.2799 84.72ZM34.2799 0.709961H0.679932V34.3101V67.91H34.2799C52.8399 67.91 67.8799 52.8701 67.8799 34.3101C67.8799 15.7501 52.8399 0.709961 34.2799 0.709961ZM118.29 151.92H151.89V118.32V84.72H118.29C99.7299 84.72 84.6899 99.76 84.6899 118.32C84.6899 136.88 99.7299 151.92 118.29 151.92ZM151.89 34.3101V0.709961H118.29H84.6899V34.3101C84.6899 52.8701 99.7299 67.91 118.29 67.91C136.85 67.92 151.89 52.8701 151.89 34.3101Z"
                  fill="white"></path>
        </svg>
      </div>
    </a>
  </div>


  <ng-container *ngIf="isLoggedIn()">

    <div class="inline-block items-center" style="margin: auto 0 auto 7px">
      <app-global-search-bar *appIfPermission="[PermissionEnum.GLOBAL_SEARCH_VIEW]"></app-global-search-bar>
    </div>
    <div class="relative ml-auto flex flex-row items-center">

      <ng-container *ngIf="(accountConfig$ | async) as accountConfig">
        <ng-container
                *ngIf="accountConfig.activeAccountProductPackage?.isTrial || accountConfig.activeAccountProductPackage?.to">

              <span class="hidden md:flex">
                <!--      <ng-container *ngTemplateOutlet="administrationLinks"></ng-container>-->

                <!--                <div class="relative my-auto" *ngIf="accountConfig.daysTillEndOfSubscription > 0; else expired">-->
                <div class="relative my-auto" *ngIf="accountConfig.daysTillEndOfSubscription >= 0">
                  <a [routerLink]="['/admin/settings/packages-page']">

                  <div
                          class="border-2 w-full p-2 flex justify-center items-center rounded"
                          [ngClass]="{'border-primary text-primary': accountConfig.daysTillEndOfSubscription > 10, 'border-yellow text-yellow': accountConfig.daysTillEndOfSubscription <= 10 && accountConfig.daysTillEndOfSubscription > 5, 'border-orange text-orange': accountConfig.daysTillEndOfSubscription <= 5}"
                  >
                    <span *ngIf="accountConfig.activeAccountProductPackage.isTrial" i18n>Testno obdobje traja še:</span>
                    <span *ngIf="!accountConfig.activeAccountProductPackage.isTrial" i18n>Naročnina traja še:</span>
                    <span class="font-bold"> &nbsp;

                    <ng-container [ngSwitch]="accountConfig.daysTillEndOfSubscription">
                      <span *ngSwitchCase="1" i18n>{{ accountConfig.daysTillEndOfSubscription }} dan</span>
                      <span *ngSwitchCase="2" i18n>{{ accountConfig.daysTillEndOfSubscription }} dneva</span>
                      <span *ngSwitchDefault i18n>{{ accountConfig.daysTillEndOfSubscription }} dni</span>
                    </ng-container>
                  </span>
                  </div>
                  </a>
                </div>
                <ng-template #expired>
                  <a [routerLink]="['/admin/settings/packages-page']">
                  <div class="relative my-auto">
                    <div
                            class="border border-2 w-full p-2 flex justify-center items-center rounded border-red text-red"
                    >
                      <span i18n>Naročnina je potekla !</span>
                    </div>
                  </div>
                  </a>
                </ng-template>
              </span>
        </ng-container>
      </ng-container>

      <div class="hidden md:inline relative my-auto" *ngIf="businessUnits?.length > 0">
        <div class="dropdown business-units-dropdown">
          <select [formControl]="businessUnitsControl">
            <option [ngValue]="ALL_BUSINESS_UNITS" i18n selected>-- VSE ENOTE --</option>
            <option *ngFor="let businessUnit of businessUnits;" [ngValue]="businessUnit.uuid">
              {{ businessUnit.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="hidden md:inline relative my-auto" *ngIf="account">
        <div class="ml-2 border-transparent px-4 py-2 border-2 rounded bg-primaryWashed">
          <div class="text-xs text-primaryDark font-semibold">
            {{ account.name }}
          </div>
        </div>
      </div>

      <div class="hidden md:inline pl-6 py-3 hover:text-primary">
        <span class="fa-stack cursor-pointer" [attr.data-count]="unreadNotifications"
              *ngIf="unreadNotifications > 0; else bell"
              (click)="toggleNotificationDropdown();">
          <i class="relative fas fa-bell inline text-grayDark fa-stack-1x fa-inverse hover:text-inherit">
          </i>
        </span>
        <ng-template #bell>
          <span class="fa-stack cursor-pointer"
                (click)="toggleNotificationDropdown();">
            <i class="relative fas fa-bell inline text-grayDark fa-stack-1x fa-inverse hover:text-inherit"></i>
          </span>
        </ng-template>
      </div>

      <div class="absolute" style="right: 50px; top: 50px;" *ngIf="isNotificationDropdownOpened">
        <app-notification-dropdown [notifications]="notifications" [totalNotifications]="totalNotifications"
                                   (closeDropdown)="toggleNotificationDropdown()"
                                   (readAllNotification)="clearUnreadNotifications()">
        </app-notification-dropdown>
      </div>

      <div class="hidden md:inline relative my-auto text-grayDark hover:text-primary">

        <button class="users px-6 shrink-0 flex flex-row items-center pl-3 py-4" type="button"
                data-test="layout-navbar-user-menu-button"
                i18n-title
                title="Uporabnik"
                (click)="toggleUserMenu()">
          <i class="fas fa-user-circle  mr-3 text-lg text-inherit"></i>

          <ng-container *ngIf="user">
            <span class="mr-3 font-bold text-xs hidden md:inline text-inherit">{{ getUser(user) }} </span>
          </ng-container>

          <i class="fas fa-chevron-down text-sm text-inherit"></i>
        </button>

        <ng-container *ngIf="isUserMenuOpened">
          <div
                  class="bg-white rounded-bl border-grayLight border rounded-br p-3 right-0 w-56 absolute flex flex-col"
                  style="margin-top:2px; z-index: 500;">
            <ng-container *ngTemplateOutlet="userMenu"></ng-container>
          </div>
        </ng-container>
      </div>
    </div>

    <button class="btn text-grayDark md:hidden btn-grayDark-link text-lg shadow-none"
            (click)="toggleHamburgerMenu()">
      <i class="fas fa-bars"></i>
    </button>
  </ng-container>
</nav>

<ng-container *ngIf="isHamburgerOpened">
  <div class="cdk-overlay-container cdk-overlay-dark-backdrop">
    <div></div>
  </div>

  <div class="fixed bottom-0 left-0 right-0 bg-white z-50 hamburger" style="z-index: 1001">
    <div class="relative">
      <div class="flex flex-row justify-between items-center">
        <p class="text-base text-grayDark font-bold ml-5 mt-3" i18n="Navbar user menu hamburger">Meni</p>
        <div class="text-right mb-1 mt-3 pr-2">
          <button (click)="toggleHamburgerMenu()" class="btn border-transparent shadow-none"><i
                  class="fas fa-times text-lg text-gray"></i></button>
        </div>
      </div>
      <hr class="mt-2 mb-0">

      <div class="card-content pt-4 overflow-y-auto pb-10" style="max-height: 70vh">
        <div class="relative my-auto" *ngIf="businessUnits?.length > 0">
          <div class="dropdown business-units-dropdown">
            <select [formControl]="businessUnitsControl">
              <option [ngValue]="ALL_BUSINESS_UNITS" i18n selected>-- VSE ENOTE --</option>
              <option *ngFor="let businessUnit of businessUnits;" [ngValue]="businessUnit.uuid">
                {{ businessUnit.name }}
              </option>
            </select>
          </div>
        </div>

        <app-sidebar [isMobile]="true">
          <div>
            <ng-container *ngTemplateOutlet="administrationLinks"></ng-container>
          </div>
        </app-sidebar>

        <hr class="mt-2">

        <div class="flex flex-col font-semibold" *ngIf="user">
          <ng-container *ngTemplateOutlet="userMenu"></ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #userMenu>

  <a [routerLink]="['/admin/settings/public-account']" *ngIf="user?.isAdmin" class="text-grayDark p-3"><i
          class="fas fa-user-cog mr-2"></i><span i18n="Navbar user menu">Nastavitve</span></a>
  <a [routerLink]="['/admin/settings/profile']" *ngIf="!user?.isAdmin" class="text-grayDark p-3"><i
          class="fas fa-user-cog mr-2"></i><span i18n="Navbar user menu">Nastavitve</span></a>
  <a (click)="openCompanionQrLogin()" class="text-grayDark p-3 cursor-pointer"><i
          class="fas fa-mobile-alt fa-fw mr-2"></i><span i18n="Navbar user menu">Prijava v CarPeak</span></a>
  <a [routerLink]="['/logout']" class="text-red p-3"><i class="fas fa-sign-out-alt mr-2"></i><span
          i18n="Navbar user menu">Odjava</span></a>

  <ng-container *ngIf="user?.isConfigurationAdmin">
    <hr class="mt-2 mb-0">
    <a [routerLink]="['/admin/settings/super-admin/accounts', account.accountUuid]" class="text-red p-3"
       data-test="navbar-usermenu-accountconfig"
    >
      <i class="fas fa-screwdriver mr-2"></i><span i18n="Navbar user menu">Account Config</span>
    </a>
    <a [routerLink]="['/admin/settings/super-admin/trading-hub', account.accountUuid]" class="text-red p-3"
       data-test="navbar-usermenu-tradinghubconfig"
    >
      <i class="fas fa-screwdriver mr-2"></i><span i18n="Navbar user menu">Trading hub Config</span>
    </a>
    <a [routerLink]="['/admin/settings/super-admin/accounts']" class="text-red p-3"
       data-test="navbar-usermenu-superaccounts"
    >
      <i class="fas fa-users mr-2"></i><span i18n="Navbar user menu">Super Accounts</span>
    </a>
    <a [routerLink]="['/admin/settings/super-admin']" class="text-red p-3"
       data-test="navbar-usermenu-dashboard"
    >
      <i class="fas fa-tachometer-alt mr-2"></i><span i18n="Navbar user menu">Dashboard</span>
    </a>
  </ng-container>
</ng-template>

<ng-template #administrationLinks>
  <!--  <a *ngIf="hasAdministration && !isInAdministration && !hasAdministrationV2" title="Administracija"-->
  <!--     i18n-title="Navbar link"-->
  <!--     [routerLink]="getAdministrationUrl()"-->
  <!--     class="py-4 text-administration hover:no-underline font-bold text-sm hover:no-underline no-underline">-->
  <!--    <span class="text-lg opacity-75 w-12"><i class="fas fa-file-alt mr-2"></i></span>-->
  <!--    <span i18n="Navbar link">Administracija</span>-->
  <!--  </a>-->

  <!--  <a *ngIf="hasAdministration && isInAdministration && !hasAdministrationV2" title="Nazaj" i18n-title="Navbar link"-->
  <!--     [routerLink]="['/admin']" class="py-4 px-6 text-primary hover:no-underline no-underline font-bold text-sm">-->
  <!--    <span class="text-lg opacity-75 w-12"><i class="fas fa-arrow-left mr-2"></i></span>-->
  <!--    <span i18n="Navbar link">Nazaj v AutoBrief</span>-->
  <!--  </a>-->
</ng-template>
